// ACCOUNT
export const UPDATE_ACCOUNT_NAME = 'UPDATE_ACCOUNT_NAME';

// ADVANCED REPORT EXECUTION
export const UPDATE_ADVANCEDREPORTEXECUTION_TYPE = 'UPDATE_ADVANCEDREPORTEXECUTION_TYPE';
export const UPDATE_ADVANCEDREPORTEXECUTION_BREAKDOWN = 'UPDATE_ADVANCEDREPORTEXECUTION_BREAKDOWN';
export const UPDATE_ADVANCEDREPORTEXECUTION_DATES = 'UPDATE_ADVANCEDREPORTEXECUTION_DATES';
export const UPDATE_ADVANCEDREPORTEXECUTION_TIMEZONE = 'UPDATE_ADVANCEDREPORTEXECUTION_TIMEZONE';
export const UPDATE_ADVANCEDREPORTEXECUTION_EMAILS = 'UPDATE_ADVANCEDREPORTEXECUTION_EMAILS';

// ADVANCED REPORT SCHEDULES
export const UPDATE_ADVANCEDREPORTSCHEDULE_REPORTTYPE = 'UPDATE_ADVANCEDREPORTSCHEDULE_REPORTTYPE';
export const UPDATE_ADVANCEDREPORTSCHEDULE_REPORTPARAMETERS = 'UPDATE_ADVANCEDREPORTSCHEDULE_REPORTPARAMETERS';
export const UPDATE_ADVANCEDREPORTSCHEDULE_EXECUTIONTIMEZONE = 'UPDATE_ADVANCEDREPORTSCHEDULE_EXECUTIONTIMEZONE';
export const UPDATE_ADVANCEDREPORTSCHEDULE_FIRSTEVENT = 'UPDATE_ADVANCEDREPORTSCHEDULE_FIRSTEVENT';
export const UPDATE_ADVANCEDREPORTSCHEDULE_LASTEVENT = 'UPDATE_ADVANCEDREPORTSCHEDULE_LASTEVENT';
export const UPDATE_ADVANCEDREPORTSCHEDULE_RECURRINGPERIOD = 'UPDATE_ADVANCEDREPORTSCHEDULE_RECURRINGPERIOD';
export const UPDATE_ADVANCEDREPORTSCHEDULE_DAYOFMONTH = 'UPDATE_ADVANCEDREPORTSCHEDULE_DAYOFMONTH';
export const UPDATE_ADVANCEDREPORTSCHEDULE_NOTIFICATIONS = 'UPDATE_ADVANCEDREPORTSCHEDULE_NOTIFICATIONS';

// ADVERTISER
export const UPDATE_ADVERTISER_DOMAIN = 'UPDATE_ADVERTISER_DOMAIN';
export const UPDATE_ADVERTISER_MINSECONDSBETWEENPLAYS = 'UPDATE_ADVERTISER_MINSECONDSBETWEENPLAYS';
export const UPDATE_ADVERTISER_NAME = 'UPDATE_ADVERTISER_NAME';

// AUDIENCE FILE
export const UPDATE_AUDIENCEFILE_NAME = 'UPDATE_AUDIENCEFILE_NAME';

// AUDIENCE LOGIC
export const UPDATE_AUDIENCELOGIC_AUDIENCERULES = 'UPDATE_AUDIENCELOGIC_AUDIENCERULES';
export const UPDATE_AUDIENCELOGIC_DATAPROVIDERID = 'UPDATE_AUDIENCELOGIC_DATAPROVIDERID';
export const UPDATE_AUDIENCELOGIC_DATAMARKETPLACEID = 'UPDATE_AUDIENCELOGIC_DATAMARKETPLACEID';
export const UPDATE_AUDIENCELOGIC_EXTERNALDEMOGRAPHICIDS = 'UPDATE_AUDIENCELOGIC_EXTERNALDEMOGRAPHICIDS';
export const UPDATE_AUDIENCELOGIC_LOGICALEXPRESSION = 'UPDATE_AUDIENCELOGIC_LOGICALEXPRESSION';
export const UPDATE_AUDIENCELOGIC_NAME = 'UPDATE_AUDIENCELOGIC_NAME';
export const UPDATE_AUDIENCELOOKBACKWINDOW_CANDIDATEFREQUENCY = 'UPDATE_AUDIENCELOOKBACKWINDOW_CANDIDATEFREQUENCY';
export const UPDATE_AUDIENCELOOKBACKWINDOW_FROMDATE = 'UPDATE_AUDIENCELOOKBACKWINDOW_FROMDATE';
export const UPDATE_AUDIENCELOOKBACKWINDOW_ISRELATIVE = 'UPDATE_AUDIENCELOOKBACKWINDOW_ISRELATIVE';
export const UPDATE_AUDIENCELOOKBACKWINDOW_PERIODTYPE = 'UPDATE_AUDIENCELOOKBACKWINDOW_PERIODTYPE';
export const UPDATE_AUDIENCELOOKBACKWINDOW_TIMEPERIOD = 'UPDATE_AUDIENCELOOKBACKWINDOW_TIMEPERIOD';
export const UPDATE_AUDIENCELOOKBACKWINDOW_TODATE = 'UPDATE_AUDIENCELOOKBACKWINDOW_TODATE';
export const UPDATE_AUDIENCERULE_DAYPART = 'UPDATE_AUDIENCERULE_DAYPART';
export const UPDATE_AUDIENCERULE_EXTERNALDEMOGRAPHICID = 'UPDATE_AUDIENCERULE_EXTERNALDEMOGRAPHICID';
export const UPDATE_AUDIENCERULE_GEOFENCEGROUPID = 'UPDATE_AUDIENCERULE_GEOFENCEGROUPID';
export const UPDATE_AUDIENCERULE_ISCUSTOMDAYPART = 'UPDATE_AUDIENCERULE_ISCUSTOMDAYPART';
export const UPDATE_AUDIENCERULE_ISNEGATED = 'UPDATE_AUDIENCERULE_ISNEGATED';
export const UPDATE_AUDIENCEGROUP_OPERATOR = 'UPDATE_AUDIENCEGROUP_OPERATOR';
export const UPDATE_AUDIENCERULE_KEY = 'UPDATE_AUDIENCERULE_KEY';
export const UPDATE_AUDIENCERULE_SEGMENTS = 'UPDATE_AUDIENCERULE_LIFESIGHT_SEGMENTS';
export const UPDATE_AUDIENCERULE_LOOKBACKWINDOWS = 'UPDATE_AUDIENCERULE_LOOKBACKWINDOWS';
export const UPDATE_AUDIENCERULE_NAME = 'UPDATE_AUDIENCERULE_NAME';
export const UPDATE_AUDIENCERULE_CUSTOM_GROUP_S3PATH = 'UPDATE_AUDIENCERULE_DEVICE_ID_GROUP_S3PATH';
export const UPDATE_AUDIENCERULE_CUSTOM_GROUP = 'UPDATE_AUDIENCERULE_DEVICE_ID_GROUP';
export const UPDATE_AUDIENCERULE_CUSTOM_GROUP_NAME = 'UPDATE_AUDIENCERULE_DEVICE_ID_GROUP_NAME';
export const UPDATE_AUDIENCERULE_DATAPROVIDER_ID = 'UPDATE_AUDIENCERULE_DATAPROVIDER_ID';
export const UPDATE_NODE_OPERATOR = 'UPDATE_NODE_OPERATOR';
export const UPDATE_NODES = 'UPDATE_NODES';

// CAMPAIGNS
export const UPDATE_CAMPAIGN_ACCOUNT_ID = 'UPDATE_CAMPAIGN_ACCOUNT_ID';
export const UPDATE_CAMPAIGN_ADVERTISER_ID = 'UPDATE_CAMPAIGN_ADVERTISER_ID';
export const UPDATE_CAMPAIGN_BUDGET = 'UPDATE_CAMPAIGN_BUDGET';
export const UPDATE_CAMPAIGN_BUDGET_CAP = 'UPDATE_CAMPAIGN_BUDGET_CAP';
export const UPDATE_CAMPAIGN_DAILYCAP = 'UPDATE_CAMPAIGN_DAILYCAP';
export const UPDATE_CAMPAIGN_DELIVERY_HOURLY_STATS = 'UPDATE_CAMPAIGN_DELIVERY_HOURLY_STATS';
export const UPDATE_CAMPAIGN_ENDDATE = 'UPDATE_CAMPAIGN_ENDDATE';
export const UPDATE_CAMPAIGN_FLIGHT_STARTDATE = 'UPDATE_CAMPAIGN_FLIGHT_STARTDATE';
export const UPDATE_CAMPAIGN_FLIGHT_ENDATE = 'UPDATE_CAMPAIGN_FLIGHT_ENDATE';
export const UPDATE_CAMPAIGN_FLIGHT_GOAL = 'UPDATE_CAMPAIGN_FLIGHT_GOAL';
export const UPDATE_CAMPAIGN_FLIGHTS = 'UPDATE_CAMPAIGN_FLIGHTS';
export const UPDATE_CAMPAIGN_INSERTION_ORDER_BUDGET = 'UPDATE_CAMPAIGN_INSERTION_ORDER_BUDGET';
export const UPDATE_CAMPAIGN_INTERNAL_PROPERTIES = 'UPDATE_CAMPAIGN_INTERNAL_PROPERTIES';
export const UPDATE_CAMPAIGN_LINE_ITEMS = 'UPDATE_CAMPAIGN_LINE_ITEMS';
export const UPDATE_CAMPAIGN_MARGINS = 'UPDATE_CAMPAIGN_MARGINS';
export const UPDATE_CAMPAIGN_MINSECONDSBETWEENPLAYS = 'UPDATE_CAMPAIGN_MINSECONDSBETWEENPLAYS';
export const UPDATE_CAMPAIGN_NAME = 'UPDATE_CAMPAIGN_NAME';
export const UPDATE_CAMPAIGN_NOTES = 'UPDATE_CAMPAIGN_NOTES';
export const UPDATE_CAMPAIGN_PACINGBUDGET = 'UPDATE_CAMPAIGN_PACINGBUDGET';
export const UPDATE_CAMPAIGN_PACINGBUDGETMODE = 'UPDATE_CAMPAIGN_PACINGBUDGETMODE';
export const UPDATE_CAMPAIGN_PACINGMODIFIEDAT = 'UPDATE_CAMPAIGN_PACINGMODIFIEDAT';
export const UPDATE_CAMPAIGN_PACINGSTRATEGY = 'UPDATE_CAMPAIGN_PACINGSTRATEGY';
export const UPDATE_CAMPAIGN_PRIORITY = 'UPDATE_CAMPAIGN_PRIORITY';
export const UPDATE_CAMPAIGN_PLAN_ID = 'UPDATE_CAMPAIGN_PLAN_ID';
export const UPDATE_CAMPAIGN_PROPERTIES = 'UPDATE_CAMPAIGN_PROPERTIES';
export const UPDATE_CAMPAIGN_REACH_AND_FREQUENCY_REQUESTED = 'UPDATE_CAMPAIGN_REACH_AND_FREQUENCY_REQUESTED';
export const UPDATE_CAMPAIGN_SHAREDENTITY = 'UPDATE_CAMPAIGN_SHAREDENTITY';
export const UPDATE_CAMPAIGN_STARTDATE = 'UPDATE_CAMPAIGN_STARTDATE';
export const UPDATE_CAMPAIGN_TYPE = 'UPDATE_CAMPAIGN_TYPE';
export const UPDATE_CAMPAIGN_IS_TEST = 'UPDATE_CAMPAIGN_IS_TEST';
export const UPDATE_CAMPAIGN_ADVERTISER_BUDGET = 'UPDATE_CAMPAIGN_ADVERTISER_BUDGET';

// CREATIVES
export const UPDATE_CREATIVE_ADVERTISER_ID = 'UPDATE_CREATIVE_ADVERTISER_ID';
export const UPDATE_CREATIVE_APPROVAL_COMMENT = 'UPDATE_CREATIVE_APPROVAL_COMMENT';
export const UPDATE_CREATIVE_CREATIVEFILES = 'UPDATE_CREATIVE_CREATIVEFILES';
export const UPDATE_CREATIVE_CREATIVEFORMATEXCLUSIONS = 'UPDATE_CREATIVE_CREATIVEFORMATEXCLUSIONS';
export const UPDATE_CREATIVE_CREATIVEFORMATS = 'UPDATE_CREATIVE_CREATIVEFORMATS';
export const UPDATE_CREATIVE_CREATIVEORIENTATIONS = 'UPDATE_CREATIVE_CREATIVEORIENTATIONS';
export const UPDATE_CREATIVE_CREATIVEORIENTATIONEXCLUSIONS = 'UPDATE_CREATIVE_CREATIVEORIENTATIONEXCLUSIONS';
export const UPDATE_CREATIVE_CREATIVEPROPERTIES = 'UPDATE_CREATIVE_CREATIVEPROPERTIES';
export const UPDATE_CREATIVE_CREATIVETRACKINGURLS = 'UPDATE_CREATIVE_CREATIVETRACKINGURLS';
export const UPDATE_CREATIVE_CREATIVETYPE = 'UPDATE_CREATIVE_CREATIVETYPE';
export const UPDATE_CREATIVE_DAYPART = 'UPDATE_CREATIVE_DAYPART';
export const UPDATE_CREATIVE_PRECISE_DAYPART = 'UPDATE_CREATIVE_PRECISE_DAYPART';
export const UPDATE_CREATIVE_GEOFENCE_GROUP_IDS = 'UPDATE_CREATIVE_GEOFENCE_GROUP_IDS';
export const UPDATE_CREATIVE_GEOFENCE_GROUP_EXCLUSION_IDS = 'UPDATE_CREATIVE_GEOFENCE_GROUP_EXCLUSION_IDS';
export const UPDATE_CREATIVE_IAB_CATEGORY_IDS = 'UPDATE_CREATIVE_IAB_CATEGORY_IDS';
export const UPDATE_CREATIVE_IS_FALLBACK = 'UPDATE_CREATIVE_IS_FALLBACK';
export const UPDATE_CREATIVE_IS_MOBILE = 'UPDATE_CREATIVE_IS_MOBILE';
export const UPDATE_CREATIVE_LANGUAGE_IDS = 'UPDATE_CREATIVE_LANGUAGE_IDS';
export const UPDATE_CREATIVE_LINEITEMS = 'UPDATE_CREATIVE_LINEITEMS';
export const UPDATE_CREATIVE_LOCATIONIDS = 'UPDATE_CREATIVE_LOCATIONIDS';
export const UPDATE_CREATIVE_LOCATIONEXCLUSIONIDS = 'UPDATE_CREATIVE_LOCATIONEXCLUSIONIDS';
export const UPDATE_CREATIVE_MARKET_IDS = 'UPDATE_CREATIVE_MARKET_IDS';
export const UPDATE_CREATIVE_MARKETEXCLUSIONIDS = 'UPDATE_CREATIVE_MARKETEXCLUSIONIDS';
export const UPDATE_CREATIVE_MATCHING_CREATIVE_SIZES = 'UPDATE_CREATIVE_MATCHING_CREATIVE_SIZES';
export const UPDATE_CREATIVE_MEDIATYPEIDS = 'UPDATE_CREATIVE_MEDIATYPEIDS';
export const UPDATE_CREATIVE_MEDIATYPEEXCLUSIONIDS = 'UPDATE_CREATIVE_MEDIATYPEEXCLUSIONIDS';
export const UPDATE_CREATIVE_MISSING_CREATIVE_SIZES = 'UPDATE_CREATIVE_MISSING_CREATIVE_SIZES';
export const UPDATE_CREATIVE_NAME = 'UPDATE_CREATIVE_NAME';
export const UPDATE_CREATIVE_NETWORKIDS = 'UPDATE_CREATIVE_NETWORKIDS';
export const UPDATE_CREATIVE_NETWORKEXCLUSIONIDS = 'UPDATE_CREATIVE_NETWORKEXCLUSIONIDS';
export const UPDATE_CREATIVE_OVERRIDEDEFAULTDURATION = 'UPDATE_CREATIVE_OVERRIDEDEFAULTDURATION';
export const UPDATE_CREATIVE_RUNSTATE = 'UPDATE_CREATIVE_RUNSTATE';
export const UPDATE_CREATIVE_SITEIDS = 'UPDATE_CREATIVE_SITEIDS';
export const UPDATE_CREATIVE_SITEEXCLUSIONIDS = 'UPDATE_CREATIVE_SITEEXCLUSIONIDS';
export const UPDATE_CREATIVE_STATE = 'UPDATE_CREATIVE_STATE';
export const UPDATE_CREATIVE_TARGETING_CRITERIA = 'UPDATE_CREATIVE_TARGETING_CRITERIA';
export const UPDATE_CREATIVE_UNITIDS = 'UPDATE_CREATIVE_UNITIDS';
export const UPDATE_CREATIVE_UNITEXCLUSIONIDS = 'UPDATE_CREATIVE_UNITEXCLUSIONIDS';
export const UPDATE_CREATIVE_UNITTAGS = 'UPDATE_CREATIVE_UNITTAGS';
export const UPDATE_CREATIVE_UNITTAGEXCLUSIONS = 'UPDATE_CREATIVE_UNITTAGEXCLUSIONS';
export const UPDATE_CREATIVE_UNITPACKIDS = 'UPDATE_CREATIVE_UNITPACKIDS';
export const UPDATE_CREATIVE_UNITPACKEXCLUSIONIDS = 'UPDATE_CREATIVE_UNITPACKEXCLUSIONIDS';

// CUSTOM EVENTS
export const UPDATE_CUSTOM_EVENT_CATEGORYNAME = 'UPDATE_CUSTOM_EVENT_CATEGORYNAME';
export const UPDATE_CUSTOM_EVENT_CODE = 'UPDATE_CUSTOM_EVENT_CODE';
export const UPDATE_CUSTOM_EVENT_NAME = 'UPDATE_CUSTOM_EVENT_NAME';

// DEMOGRAPHIC
export const UPDATE_DEMOGRAPHIC_NAME = 'UPDATE_DEMOGRAPHIC_NAME';

// FLIGHTS
export const UPDATE_FLIGHT_STARTDATE = 'UPDATE_FLIGHT_STARTDATE';
export const UPDATE_FLIGHT_ENDDATE = 'UPDATE_FLIGHT_ENDDATE';
export const UPDATE_FLIGHT_GOAL = 'UPDATE_FLIGHT_GOAL';

// GEOFENCE GROUPS
export const UPDATE_GEOFENCE_EXTRUSION = 'UPDATE_GEOFENCE_EXTRUSION';
export const UPDATE_GEOFENCE_GEOFENCEGROUPID = 'UPDATE_GEOFENCE_GEOFENCEGROUPID';
export const UPDATE_GEOFENCE_GEOJSON = 'UPDATE_GEOFENCE_GEOJSON';
export const UPDATE_GEOFENCE_GROUP_DESCRIPTION = 'UPDATE_GEOFENCE_GROUP_DESCRIPTION';
export const UPDATE_GEOFENCE_GROUP_GEOFENCES = 'UPDATE_GEOFENCE_GROUP_GEOFENCES';
export const UPDATE_GEOFENCE_GROUP_NAME = 'UPDATE_GEOFENCE_GROUP_NAME';
export const UPDATE_GEOFENCE_GROUP_TAGS = 'UPDATE_GEOFENCE_GROUP_TAGS';
export const UPDATE_GEOFENCE_ISPOINT = 'UPDATE_GEOFENCE_ISPOINT';
export const UPDATE_GEOFENCE_LAT = 'UPDATE_GEOFENCE_LAT';
export const UPDATE_GEOFENCE_LNG = 'UPDATE_GEOFENCE_LNG';
export const UPDATE_GEOFENCE_MAPBOXDRAWID = 'UPDATE_GEOFENCE_MAPBOXDRAWID';
export const UPDATE_GEOFENCE_NELAT = 'UPDATE_GEOFENCE_NELAT';
export const UPDATE_GEOFENCE_NELNG = 'UPDATE_GEOFENCE_NELNG';
export const UPDATE_GEOFENCE_RADIUS = 'UPDATE_GEOFENCE_RADIUS';
export const UPDATE_GEOFENCE_RADIUS_UNIT = 'UPDATE_GEOFENCE_RADIUS_UNIT';
export const UPDATE_GEOFENCE_RADIUS_IN_UNIT = 'UPDATE_GEOFENCE_RADIUS_IN_UNIT';
export const UPDATE_GEOFENCE_SWLAT = 'UPDATE_GEOFENCE_SWLAT';
export const UPDATE_GEOFENCE_SWLNG = 'UPDATE_GEOFENCE_SWLNG';

// LINEITEMS
export const UPDATE_EXCHANGE_FEE_OVERRIDE_TYPE = 'UPDATE_EXCHANGE_FEE_OVERRIDE_TYPE';
export const UPDATE_EXCHANGE_FEE_OVERRIDE_VALUE = 'UPDATE_EXCHANGE_FEE_OVERRIDE_VALUE';
export const UPDATE_LINEITEM_ADDURATION = 'UPDATE_LINEITEM_ADDURATION';
export const UPDATE_LINEITEM_APPROVAL_COMMENT = 'UPDATE_LINEITEM_APPROVAL_COMMENT';
export const UPDATE_LINEITEM_BIDDING_TYPE = 'UPDATE_LINEITEM_BIDDING_TYPE';
export const UPDATE_LINEITEM_BUDGET = 'UPDATE_LINEITEM_BUDGET';
export const UPDATE_LINEITEM_BUDGET_MODE = 'UPDATE_LINEITEM_BUDGET_MODE';
export const UPDATE_LINEITEM_BUY_FROM_DEALS_ENABLED = 'UPDATE_LINEITEM_BUY_FROM_DEALS_ENABLED';
export const UPDATE_LINEITEM_CADENCE = 'UPDATE_LINEITEM_CADENCE';
export const UPDATE_LINEITEM_CADENCE_SMOOTH_CATCHUP = 'UPDATE_LINEITEM_CADENCE_SMOOTH_CATCHUP';
export const UPDATE_LINEITEM_CAMPAIGN = 'UPDATE_LINEITEM_CAMPAIGN';
export const UPDATE_LINEITEM_CAMPAIGN_ID = 'UPDATE_LINEITEM_CAMPAIGN_ID';
export const UPDATE_LINEITEM_CHANNEL_TYPE = 'UPDATE_LINEITEM_CHANNEL_TYPE';
export const UPDATE_LINEITEM_COMPANION_GROUP_NAME = 'UPDATE_LINEITEM_COMPANION_GROUP_NAME';
export const UPDATE_LINEITEM_COMPANION_ORDER = 'UPDATE_LINEITEM_COMPANION_ORDER';
export const UPDATE_LINEITEM_CPM = 'UPDATE_LINEITEM_CPM';
export const UPDATE_LINEITEM_CPM_CALCULATOR = 'UPDATE_LINEITEM_CPM_CALCULATOR';
export const UPDATE_LINEITEM_CREATIVEFORMATEXCLUSIONS = 'UPDATE_LINEITEM_CREATIVEFORMATEXCLUSIONS';
export const UPDATE_LINEITEM_CREATIVEFORMATS = 'UPDATE_LINEITEM_CREATIVEFORMATS';
export const UPDATE_LINEITEM_CREATIVEORIENTATIONS = 'UPDATE_LINEITEM_CREATIVEORIENTATIONS';
export const UPDATE_LINEITEM_CREATIVEORIENTATIONEXCLUSIONS = 'UPDATE_LINEITEM_CREATIVEORIENTATIONEXCLUSIONS';
export const UPDATE_LINEITEM_CREATIVEIDS = 'UPDATE_LINEITEM_CREATIVEIDS';
export const UPDATE_LINEITEM_CREATIVES = 'UPDATE_LINEITEM_CREATIVES';
export const UPDATE_LINEITEM_DAILY_GOAL_CAP = 'UPDATE_LINEITEM_DAILY_GOAL_CAP';
export const UPDATE_LINEITEM_DAILY_DELIVERY_HOURLY_STATS = 'UPDATE_LINEITEM_DAILY_DELIVERY_HOURLY_STATS';
export const UPDATE_LINEITEM_DAYPART = 'UPDATE_LINEITEM_DAYPART';
export const UPDATE_LINEITEM_DELIVERY_CURVE = 'UPDATE_LINEITEM_DELIVERY_CURVE';
export const UPDATE_LINEITEM_DELIVERY_HOURLY_STATS = 'UPDATE_LINEITEM_DELIVERY_HOURLY_STATS';
export const UPDATE_LINEITEM_DELIVERY_MODE = 'UPDATE_LINEITEM_DELIVERY_MODE';
export const UPDATE_LINEITEM_DEMOGRAPHICIDS = 'UPDATE_LINEITEM_DEMOGRAPHICIDS';
export const UPDATE_LINEITEM_DISCOUNTS = 'UPDATE_LINEITEM_DISCOUNTS';
export const UPDATE_LINEITEM_ENDDATE = 'UPDATE_LINEITEM_ENDDATE';
export const UPDATE_LINEITEM_ESTIMATED_AUDIENCE_CPM = 'UPDATE_LINEITEM_ESTIMATED_AUDIENCE_CPM';
export const UPDATE_LINEITEM_ESTIMATED_AVERAGE_AUDIENCE_CPM = 'UPDATE_LINEITEM_ESTIMATED_AVERAGE_AUDIENCE_CPM';
export const UPDATE_LINEITEM_ESTIMATED_AVERAGE_CPM = 'UPDATE_LINEITEM_ESTIMATED_AVERAGE_CPM';
export const UPDATE_LINEITEM_ESTIMATED_CPM = 'UPDATE_LINEITEM_ESTIMATED_CPM';
export const UPDATE_LINEITEM_EXTERNAL_ID = 'UPDATE_LINEITEM_EXTERNAL_ID';
export const UPDATE_LINEITEM_FLIGHT_RATIO = 'UPDATE_LINEITEM_FLIGHT_RATIO';
export const UPDATE_LINEITEM_IABCATEGORIES = 'UPDATE_LINEITEM_IABCATEGORIES';
export const UPDATE_LINEITEM_IABCATEGORYEXCLUSIONS = 'UPDATE_LINEITEM_IABCATEGORYEXCLUSIONS';
export const UPDATE_LINEITEM_GEOFENCE_GROUP_IDS = 'UPDATE_LINEITEM_GEOFENCE_GROUP_IDS';
export const UPDATE_LINEITEM_GEOFENCE_GROUP_EXCLUSION_IDS = 'UPDATE_LINEITEM_GEOFENCE_GROUP_EXCLUSION_IDS';
export const UPDATE_LINEITEM_HAS_INFINITE_BUDGET = 'UPDATE_LINEITEM_HAS_INFINITE_BUDGET';
export const UPDATE_LINEITEM_ID = 'UPDATE_LINEITEM_ID';
export const UPDATE_LINEITEM_IS_CPM_FROM_RATE_CARD = 'UPDATE_LINEITEM_IS_CPM_FROM_RATE_CARD';
export const UPDATE_LINEITEM_IS_MEASUREMENT_REQUESTED = 'UPDATE_LINEITEM_IS_MEASUREMENT_REQUESTED';
export const UPDATE_LINEITEM_ATTACHED_MEASUREMENTS = 'UPDATE_LINEITEM_ATTACHED_MEASUREMENTS';
export const UPDATE_LINEITEM_LANGUAGEIDS = 'UPDATE_LINEITEM_LANGUAGEIDS';
export const UPDATE_LINEITEM_LANGUAGEEXCLUSIONIDS = 'UPDATE_LINEITEM_LANGUAGEEXCLUSIONIDS';
export const UPDATE_LINEITEM_LOCATIONEXCLUSIONIDS = 'UPDATE_LINEITEM_LOCATIONEXCLUSIONIDS';
export const UPDATE_LINEITEM_LOCATIONIDS = 'UPDATE_LINEITEM_LOCATIONIDS';
export const UPDATE_LINEITEM_MARGINS = 'UPDATE_LINEITEM_MARGINS';
export const UPDATE_LINEITEM_MARKET_IDS = 'UPDATE_LINEITEM_MARKET_IDS';
export const UPDATE_LINEITEM_MARKETEXCLUSIONIDS = 'UPDATE_LINEITEM_MARKETEXCLUSIONIDS';
export const UPDATE_LINEITEM_MAXBIDCPM = 'UPDATE_LINEITEM_MAXBIDCPM';
export const UPDATE_LINEITEM_MINBIDCPM = 'UPDATE_LINEITEM_MINBIDCPM';
export const UPDATE_LINEITEM_MEDIAOWNERIDS = 'UPDATE_LINEITEM_MEDIAOWNERIDS';
export const UPDATE_LINEITEM_MEDIATYPEIDS = 'UPDATE_LINEITEM_MEDIATYPEIDS';
export const UPDATE_LINEITEM_MEDIATYPEEXCLUSIONIDS = 'UPDATE_LINEITEM_MEDIATYPEEXCLUSIONIDS';
export const UPDATE_LINEITEM_UNITTAGS = 'UPDATE_LINEITEM_UNITTAGS';
export const UPDATE_LINEITEM_UNITTAGEXCLUSIONS = 'UPDATE_LINEITEM_UNITTAGEXCLUSIONS';
export const UPDATE_LINEITEM_MIN_CONCENTRATION_FACTOR = 'UPDATE_LINEITEM_MIN_CONCENTRATION_FACTOR';
export const UPDATE_LINEITEM_MIN_CONCENTRATION_VALUE = 'UPDATE_LINEITEM_MIN_CONCENTRATION_VALUE';
export const UPDATE_LINEITEM_MINSECONDSBETWEENPLAYS = 'UPDATE_LINEITEM_MINSECONDSBETWEENPLAYS';
export const UPDATE_LINEITEM_NETWORKFREQUENCYCAPS = 'UPDATE_LINEITEM_NETWORKFREQUENCYCAPS';
export const UPDATE_LINEITEM_MISSING_CREATIVE_SIZES = 'UPDATE_LINEITEM_MISSING_CREATIVE_SIZES';
export const UPDATE_LINEITEM_NAME = 'UPDATE_LINEITEM_NAME';
export const UPDATE_LINEITEM_NETWORKIDS = 'UPDATE_LINEITEM_NETWORKIDS';
export const UPDATE_LINEITEM_NETWORKEXCLUSIONIDS = 'UPDATE_LINEITEM_NETWORKEXCLUSIONIDS';
export const UPDATE_LINEITEM_NOTES = 'UPDATE_LINEITEM_NOTES';
export const UPDATE_LINEITEM_PACKAGE = 'UPDATE_LINEITEM_PACKAGE';
export const UPDATE_LINEITEM_PACKAGE_ID = 'UPDATE_LINEITEM_PACKAGE_ID';
export const UPDATE_LINEITEM_POSTAL_CODES_FILES = 'UPDATE_LINEITEM_POSTAL_CODES_FILES';
export const UPDATE_LINEITEM_PACKAGEGROUP_ID = 'UPDATE_LINEITEM_PACKAGEGROUP_ID';
export const UPDATE_LINEITEM_PRIORITY = 'UPDATE_LINEITEM_PRIORITY';
export const UPDATE_LINEITEM_PRODUCTIDS = 'UPDATE_LINEITEM_PRODUCTIDS';
export const UPDATE_LINEITEM_PROPERTIES = 'UPDATE_LINEITEM_PROPERTIES';
export const UPDATE_LINEITEM_PURCHASE_TYPE = 'UPDATE_LINEITEM_PURCHASE_TYPE';
export const UPDATE_LINEITEM_RUNSTATE = 'UPDATE_LINEITEM_RUNSTATE';
export const UPDATE_LINEITEM_SITEEXCLUSIONIDS = 'UPDATE_LINEITEM_SITEEXCLUSIONIDS';
export const UPDATE_LINEITEM_SITEIDS = 'UPDATE_LINEITEM_SITEIDS';
export const UPDATE_LINEITEM_STARTDATE = 'UPDATE_LINEITEM_STARTDATE';
export const UPDATE_LINEITEM_STATE = 'UPDATE_LINEITEM_STATE';
export const UPDATE_LINEITEM_TARGETIMPRESSIONS = 'UPDATE_LINEITEM_TARGETIMPRESSIONS';
export const UPDATE_LINEITEM_TARGETING_CRITERIA = 'UPDATE_LINEITEM_TARGETING_CRITERIA';
export const UPDATE_LINEITEM_TIMESTAMP = 'UPDATE_LINEITEM_TIMESTAMP';
export const UPDATE_LINEITEM_UNITEXCLUSIONIDS = 'UPDATE_LINEITEM_UNITEXCLUSIONIDS';
export const UPDATE_LINEITEM_UNITIDS = 'UPDATE_LINEITEM_UNITIDS';
export const UPDATE_LINEITEM_UNITPACKEXCLUSIONIDS = 'UPDATE_LINEITEM_UNITPACKEXCLUSIONIDS';
export const UPDATE_LINEITEM_UNITPACKIDS = 'UPDATE_LINEITEM_UNITPACKIDS';
export const UPDATE_LINEITEM_PACKAGEGROUP_DEALS = 'UPDATE_LINEITEM_PACKAGEGROUP_DEALS';
export const UPDATE_LINEITEM_ENTITY_FEES = 'UPDATE_LINEITEM_ENTITY_FEES';
export const UPDATE_LINEITEM_ADVERTISER_BUDGET = 'UPDATE_LINEITEM_ADVERTISER_BUDGET';
export const UPDATE_LINEITEM_ADD_FEATURE_KEY = 'UPDATE_LINEITEM_ADD_FEATURE_KEY';
export const UPDATE_LINEITEM_REMOVE_FEATURE_KEY = 'UPDATE_LINEITEM_REMOVE_FEATURE_KEY';
export const UPDATE_LINEITEM_IS_OFFLINE_ENABLED = 'UPDATE_LINEITEM_IS_OFFLINE_ENABLED';
// MARGINS
export const UPDATE_MARGIN_NAME = 'UPDATE_MARGIN_NAME';

// MOBILELINEITEMS
export const UPDATE_MOBILE_LINEITEM_NAME = 'UPDATE_MOBILE_LINEITEM_NAME';
export const UPDATE_MOBILE_LINEITEM_CAMPAIGN_ID = 'UPDATE_MOBILE_LINEITEM_CAMPAIGN_ID';
export const UPDATE_MOBILE_LINEITEM_START_DATE = 'UPDATE_MOBILE_LINEITEM_START_DATE';
export const UPDATE_MOBILE_LINEITEM_END_DATE = 'UPDATE_MOBILE_LINEITEM_END_DATE';
export const UPDATE_MOBILE_LINEITEM_BUDGET = 'UPDATE_MOBILE_LINEITEM_BUDGET';
export const UPDATE_MOBILE_LINEITEM_USE_LINEITEM_GEO_TARGETING = 'UPDATE_MOBILE_LINEITEM_USE_LINEITEM_GEO_TARGETING';
export const UPDATE_MOBILE_LINEITEM_CREATIVES = 'UPDATE_MOBILE_LINEITEM_CREATIVES';
export const UPDATE_MOBILE_LINEITEM_CREATIVE_IDS = 'UPDATE_MOBILE_LINEITEM_CREATIVE_IDS';
export const UPDATE_MOBILE_LINEITEM_LINEITEMS = 'UPDATE_MOBILE_LINEITEM_LINEITEMS';
export const UPDATE_MOBILE_LINEITEM_LINEITEM_IDS = 'UPDATE_MOBILE_LINEITEM_LINEITEM_IDS';
export const UPDATE_MOBILE_LINEITEM_STATE = 'UPDATE_MOBILE_LINEITEM_STATE';
export const UPDATE_MOBILE_LINEITEM_NOTES = 'UPDATE_MOBILE_LINEITEM_NOTES';
export const UPDATE_MOBILE_LINEITEM_MAX_BID_CPM = 'UPDATE_MOBILE_LINEITEM_MAX_BID_CPM';
export const UPDATE_MOBILE_LINEITEM_FREQ_CAP_COUNT = 'UPDATE_MOBILE_LINEITEM_FREQ_CAP_COUNT';
export const UPDATE_MOBILE_LINEITEM_FREQ_CAP_PERIOD = 'UPDATE_MOBILE_LINEITEM_FREQ_CAP_PERIOD';
export const UPDATE_MOBILE_LINEITEM_FORMAT = 'UPDATE_MOBILE_LINEITEM_FORMAT';
export const UPDATE_MOBILE_LINEITEM_GOAL = 'UPDATE_MOBILE_LINEITEM_GOAL';

// NETWORKS
export const UPDATE_NETWORK_NAME = 'UPDATE_NETWORK_NAME';
export const UPDATE_NETWORK_CODE = 'UPDATE_NETWORK_CODE';
export const UPDATE_NETWORK_SPOT_LENGTH = 'UPDATE_NETWORK_SPOT_LENGTH';
export const UPDATE_NETWORK_LOOP_LENGTH = 'UPDATE_NETWORK_LOOP_LENGTH';

// ORGANIZATIONCUSTOMFIELDS
export const UPDATE_ORGANIZATIONCUSTOMFIELD_NAME = 'UPDATE_ORGANIZATIONCUSTOMFIELD_NAME';
export const UPDATE_ORGANIZATIONCUSTOMFIELD_KEY = 'UPDATE_ORGANIZATIONCUSTOMFIELD_KEY';
export const UPDATE_ORGANIZATIONCUSTOMFIELD_TYPE = 'UPDATE_ORGANIZATIONCUSTOMFIELD_TYPE';
export const UPDATE_ORGANIZATIONCUSTOMFIELD_IS_REQUIRED = 'UPDATE_ORGANIZATIONCUSTOMFIELD_IS_REQUIRED';

// OWNER_YIELD_MANAGER_SSPS
export const UPDATE_OWNER_YIELD_MANAGER_SSP_NAME = 'UPDATE_OWNER_YIELD_MANAGER_SSP_NAME';
export const UPDATE_OWNER_YIELD_MANAGER_SSP_DOMAIN = 'UPDATE_OWNER_YIELD_MANAGER_SSP_DOMAIN';
export const UPDATE_OWNER_YIELD_MANAGER_SSP_RESPONSETIMEOUT = 'UPDATE_OWNER_YIELD_MANAGER_SSP_RESPONSETIMEOUT';
export const UPDATE_OWNER_YIELD_MANAGER_SSP_NOTES = 'UPDATE_OWNER_YIELD_MANAGER_SSP_NOTES';
export const UPDATE_OWNER_YIELD_MANAGER_SSP_ISACTIVE = 'UPDATE_OWNER_YIELD_MANAGER_SSP_ISACTIVE';
export const UPDATE_OWNER_YIELD_MANAGER_SSP_APIKEY = 'UPDATE_OWNER_YIELD_MANAGER_SSP_APIKEY';

// PACKAGES
export const UPDATE_PACKAGE_AD_DURATION_MAX = 'UPDATE_PACKAGE_AD_DURATION_MAX';
export const UPDATE_PACKAGE_AD_DURATION_MIN = 'UPDATE_PACKAGE_AD_DURATION_MIN';
export const UPDATE_PACKAGE_AD_DURATION_OVERRIDABLE = 'UPDATE_PACKAGE_AD_DURATION_OVERRIDABLE';
export const UPDATE_PACKAGE_AUCTION_TYPE = 'UPDATE_PACKAGE_AUCTION_TYPE';
export const UPDATE_PACKAGE_BUDGET_MAX = 'UPDATE_PACKAGE_BUDGET_MAX';
export const UPDATE_PACKAGE_BUDGET_MIN = 'UPDATE_PACKAGE_BUDGET_MIN';
export const UPDATE_PACKAGE_BUDGET_MODE = 'UPDATE_PACKAGE_BUDGET_MODE';
export const UPDATE_PACKAGE_BUDGET_OVERRIDABLE = 'UPDATE_PACKAGE_BUDGET_OVERRIDABLE';
export const UPDATE_PACKAGE_BUYER_EXTERNAL_IDS = 'UPDATE_PACKAGE_BUYER_EXTERNAL_IDS';
export const UPDATE_PACKAGE_BUYER_EXTERNAL_EXCHANGE_IDS = 'UPDATE_PACKAGE_BUYER_EXTERNAL_EXCHANGE_IDS';
export const UPDATE_PACKAGE_BUYER_ORGANIZATION_DSP_IDS = 'UPDATE_PACKAGE_BUYER_ORGANIZATION_DSP_IDS';
export const UPDATE_PACKAGE_BUYER_ORGANIZATION_DSPS = 'UPDATE_PACKAGE_BUYER_ORGANIZATION_DSPS';
export const UPDATE_PACKAGE_CADENCE_MAX = 'UPDATE_PACKAGE_CADENCE_MAX';
export const UPDATE_PACKAGE_CADENCE_MIN = 'UPDATE_PACKAGE_CADENCE_MIN';
export const UPDATE_PACKAGE_CADENCE_SMOOTH_CATCHUP = 'UPDATE_PACKAGE_CADENCE_SMOOTH_CATCHUP';
export const UPDATE_PACKAGE_CO2_EMISSIONS_SCORE_THRESHOLD = 'UPDATE_PACKAGE_CO2_EMISSIONS_SCORE_THRESHOLD';
export const UPDATE_PACKAGE_CPM_FIXED = 'UPDATE_PACKAGE_BUDGET_FIXED';
export const UPDATE_PACKAGE_CPM_FROM_RATE_CARD = 'UPDATE_PACKAGE_CPM_FROM_RATE_CARD';
export const UPDATE_PACKAGE_CREATIVEFORMATEXCLUSIONS = 'UPDATE_PACKAGE_CREATIVEFORMATEXCLUSIONS';
export const UPDATE_PACKAGE_CREATIVEFORMATS = 'UPDATE_PACKAGE_CREATIVEFORMATS';
export const UPDATE_PACKAGE_CREATIVEORIENTATIONS = 'UPDATE_PACKAGE_CREATIVEORIENTATIONS';
export const UPDATE_PACKAGE_CREATIVEORIENTATIONEXCLUSIONS = 'UPDATE_PACKAGE_CREATIVEORIENTATIONEXCLUSIONS';
export const UPDATE_PACKAGE_CUSTOM_EVENT_TARGETING_OVERRIDABLE = 'UPDATE_PACKAGE_CUSTOM_EVENT_TARGETING_OVERRIDABLE';
export const UPDATE_PACKAGE_CURATOR_ORGANIZATION_IDS = 'UPDATE_PACKAGE_CURATOR_ORGANIZATION_IDS';
export const UPDATE_PACKAGE_DAYPART = 'UPDATE_PACKAGE_DAYPART';
export const UPDATE_PACKAGE_DAYPART_OVERRIDABLE = 'UPDATE_PACKAGE_DAYPART_OVERRIDABLE';
export const UPDATE_PACKAGE_DEALID = 'UPDATE_PACKAGE_DEALID';
export const UPDATE_PACKAGE_DELIVERY_STATS = 'UPDATE_PACKAGE_DELIVERY_STATS';
export const UPDATE_PACKAGE_DIRECT_BILLING = 'UPDATE_PACKAGE_DIRECT_BILLING';
export const UPDATE_PACKAGE_DEMOGRAPHIC_TARGET_IDS = 'UPDATE_PACKAGE_DEMOGRAPHIC_TARGET_IDS';
export const UPDATE_PACKAGE_DEMOGRAPHIC_TARGETS_OVERRIDABLE = 'UPDATE_PACKAGE_DEMOGRAPHIC_OVERRIDABLE';
export const UPDATE_PACKAGE_ENDDATE = 'UPDATE_PACKAGE_ENDDATE';
export const UPDATE_PACKAGE_ESTIMATED_AUDIENCE_CPM = 'UPDATE_PACKAGE_ESTIMATED_AUDIENCE_CPM';
export const UPDATE_PACKAGE_ESTIMATED_AVERAGE_AUDIENCE_CPM = 'UPDATE_PACKAGE_ESTIMATED_AVERAGE_AUDIENCE_CPM';
export const UPDATE_PACKAGE_ESTIMATED_AVERAGE_CPM = 'UPDATE_PACKAGE_ESTIMATED_AVERAGE_CPM';
export const UPDATE_PACKAGE_ESTIMATED_CPM = 'UPDATE_PACKAGE_ESTIMATED_CPM';
export const UPDATE_PACKAGE_ENTITY_FEES = 'UPDATE_PACKAGE_ENTITY_FEES';
export const UPDATE_PACKAGE_GEOFENCE_GROUP_IDS = 'UPDATE_PACKAGE_GEOFENCE_GROUP_IDS';

export const UPDATE_PACKAGE_GEOFENCE_GROUP_EXCLUSION_IDS = 'UPDATE_PACKAGE_GEOFENCE_GROUP_EXCLUSION_IDS';
export const UPDATE_PACKAGE_HIDE_UNIT_INFORMATION_IN_BID_REQUESTS =
  'UPDATE_PACKAGE_HIDE_UNIT_INFORMATION_IN_BID_REQUESTS';
export const UPDATE_PACKAGE_IABCATEGORIES = 'UPDATE_PACKAGE_IABCATEGORIES';
export const UPDATE_PACKAGE_IABCATEGORYEXCLUSIONS = 'UPDATE_PACKAGE_IABCATEGORYEXCLUSIONS';
export const UPDATE_PACKAGE_ID = 'UPDATE_PACKAGE_ID';
export const UPDATE_PACKAGE_IS_EVERGREEN = 'UPDATE_PACKAGE_IS_EVERGREEN';
export const UPDATE_PACKAGE_IS_FOR_BIDDING = 'UPDATE_PACKAGE_IS_FOR_BIDDING';
export const UPDATE_PACKAGE_IS_OPEN = 'UPDATE_PACKAGE_IS_OPEN';
export const UPDATE_PACKAGE_LANGUAGE_EXCLUSION_IDS = 'UPDATE_PACKAGE_LANGUAGE_EXCLUSION_IDS';
export const UPDATE_PACKAGE_LANGUAGE_IDS = 'UPDATE_PACKAGE_LANGUAGE_IDS';
export const UPDATE_PACKAGE_LOCATION_EXCLUSION_IDS = 'UPDATE_PACKAGE_LOCATION_EXCLUSION_IDS';
export const UPDATE_PACKAGE_LOCATION_TARGET_IDS = 'UPDATE_PACKAGE_LOCATION_TARGET_IDS';
export const UPDATE_PACKAGE_LOCATION_TARGETS_OVERRIDABLE = 'UPDATE_PACKAGE_LOCATION_TARGETS_OVERRIDABLE';
export const UPDATE_PACKAGE_MARKET_IDS = 'UPDATE_PACKAGE_MARKET_IDS';
export const UPDATE_PACKAGE_MARKET_TARGETED_IMPRESSIONS_MAX = 'UPDATE_PACKAGE_MARKET_TARGETED_IMPRESSIONS_MAX';
export const UPDATE_PACKAGE_MARKET_TARGETED_IMPRESSIONS_MIN = 'UPDATE_PACKAGE_MARKET_TARGETED_IMPRESSIONS_MIN';
export const UPDATE_PACKAGE_MARKET_TARGETED_IMPRESSIONS_OVERRIDABLE =
  'UPDATE_PACKAGE_MARKET_TARGETED_IMPRESSIONS_OVERRIDABLE';
export const UPDATE_PACKAGE_MEDIA_OWNER_IDS = 'UPDATE_PACKAGE_MEDIA_OWNER_IDS';
export const UPDATE_PACKAGE_MEDIA_TYPE_IDS = 'UPDATE_PACKAGE_MEDIA_TYPE_IDS';
export const UPDATE_PACKAGE_MEDIA_TYPES_OVERRIDABLE = 'UPDATE_PACKAGE_MEDIA_TYPES_OVERRIDABLE';
export const UPDATE_PACKAGE_MIN_CONCENTRATION_FACTOR = 'UPDATE_PACKAGE_MIN_CONCENTRATION_FACTOR';
export const UPDATE_PACKAGE_MIN_CONCENTRATION_VALUE = 'UPDATE_PACKAGE_MIN_CONCENTRATION_VALUE';
export const UPDATE_PACKAGE_MIN_SECONDS_BETWEEN_PLAYS_MAX = 'UPDATE_PACKAGE_MIN_SECONDS_BETWEEN_PLAYS_MAX';
export const UPDATE_PACKAGE_MIN_SECONDS_BETWEEN_PLAYS_MIN = 'UPDATE_PACKAGE_MIN_SECONDS_BETWEEN_PLAYS_MIN';
export const UPDATE_PACKAGE_MIN_SECONDS_BETWEEN_PLAYS_OVERRIDABLE =
  'UPDATE_PACKAGE_MIN_SECONDS_BETWEEN_PLAYS_OVERRIDABLE';
export const UPDATE_PACKAGE_NAME = 'UPDATE_PACKAGE_NAME';
export const UPDATE_PACKAGE_NETWORK_IDS = 'UPDATE_PACKAGE_NETWORK_IDS';
export const UPDATE_PACKAGE_NETWORKS_OVERRIDABLE = 'UPDATE_PACKAGE_NETWORKS_OVERRIDABLE';
export const UPDATE_PACKAGE_TARGETING_CRITERIA_OVERRIDABLE = 'UPDATE_PACKAGE_TARGETING_CRITERIA_OVERRIDABLE';
export const UPDATE_PACKAGE_NOTES = 'UPDATE_PACKAGE_NOTES';
export const UPDATE_PACKAGE_NUMBER_OF_DAYS_MAX = 'UPDATE_PACKAGE_NUMBER_OF_DAYS_MAX';
export const UPDATE_PACKAGE_NUMBER_OF_DAYS_MIN = 'UPDATE_PACKAGE_NUMBER_OF_DAYS_MIN';
export const UPDATE_PACKAGE_NUMBER_OF_DAYS_OVERRIDABLE = 'UPDATE_PACKAGE_NUMBER_OF_DAYS_OVERRIDABLE';
export const UPDATE_PACKAGE_ORGANIZATION_ID = 'UPDATE_PACKAGE_ORGANIZATION_ID';
export const UPDATE_PACKAGE_PACKAGE_IDS = 'UPDATE_PACKAGE_PACKAGE_IDS';
export const UPDATE_PACKAGE_PACKAGES = 'UPDATE_PACKAGE_PACKAGES';
export const UPDATE_PACKAGE_PROPERTIES = 'UPDATE_PACKAGE_PROPERTIES';
export const UPDATE_PACKAGE_PURCHASE_TYPE = 'UPDATE_PACKAGE_PURCHASE_TYPE';
export const UPDATE_PACKAGE_PURCHASE_TYPE_OVERRIDABLE = 'UPDATE_PACKAGE_PURCHASE_TYPE_OVERRIDABLE';
export const UPDATE_PACKAGE_SITE_EXCLUSION_IDS = 'UPDATE_PACKAGE_SITE_EXCLUSION_IDS';
export const UPDATE_PACKAGE_SITE_IDS = 'UPDATE_PACKAGE_SITE_IDS';
export const UPDATE_PACKAGE_STARTDATE = 'UPDATE_PACKAGE_STARTDATE';
export const UPDATE_PACKAGE_STATE = 'UPDATE_PACKAGE_STATE';
export const UPDATE_PACKAGE_TARGETING_CRITERIA = 'UPDATE_PACKAGE_TARGETING_CRITERIA';
export const UPDATE_PACKAGE_TIMESTAMP = 'UPDATE_PACKAGE_TIMESTAMP';
export const UPDATE_PACKAGE_UNIT_ASSIGNMENTS_OVERRIDABLE = 'UPDATE_PACKAGE_UNIT_ASSIGNMENTS_OVERRIDABLE';
export const UPDATE_PACKAGE_UNIT_EXCLUSION_IDS = 'UPDATE_PACKAGE_UNIT_EXCLUSION_IDS';
export const UPDATE_PACKAGE_UNIT_IDS = 'UPDATE_PACKAGE_UNIT_IDS';
export const UPDATE_PACKAGE_UNITPACK_EXCLUSION_IDS = 'UPDATE_PACKAGE_UNITPACK_EXCLUSION_IDS';
export const UPDATE_PACKAGE_UNITPACK_IDS = 'UPDATE_PACKAGE_UNITPACK_IDS';
export const UPDATE_PACKAGE_UNITTAGS = 'UPDATE_PACKAGE_UNITTAGS';
export const UPDATE_PACKAGE_UNITTAGEXCLUSIONS = 'UPDATE_PACKAGE_UNITTAGEXCLUSIONS';
export const UPDATE_PACKAGE_PLAN_ID = 'UPDATE_PACKAGE_PLAN_ID';
export const UPDATE_PACKAGE_CURATION_TYPE = 'UPDATE_PACKAGE_CURATION_TYPE';
export const UPDATE_PACKAGE_SPEND_STEERING = 'UPDATE_PACKAGE_SPEND_STEERING';

// PLANS
export const UPDATE_PLAN_ACCOUNT_ID = 'UPDATE_PLAN_ACCOUNT_ID';
export const UPDATE_PLAN_ADDURATION = 'UPDATE_PLAN_ADDURATION';
export const UPDATE_PLAN_ADVERTISER_ID = 'UPDATE_PLAN_ADVERTISER_ID';
export const UPDATE_PLAN_BREAKDOWNTYPE = 'UPDATE_PLAN_BREAKDOWNTYPE';
export const UPDATE_PLAN_BUDGET = 'UPDATE_PLAN_BUDGET';
export const UPDATE_PLAN_BUDGET_MODE = 'UPDATE_PLAN_BUDGET_MODE';
export const UPDATE_PLAN_BUY_FROM_DEALS_ENABLED = 'UPDATE_PLAN_BUY_FROM_DEALS_ENABLED';
export const UPDATE_PLAN_CPM = 'UPDATE_PLAN_CPM';
export const UPDATE_PLAN_CPM_CALCULATOR = 'UPDATE_PLAN_CPM_CALCULATOR';
export const UPDATE_PLAN_CREATIVEFORMATEXCLUSIONS = 'UPDATE_PLAN_CREATIVEFORMATEXCLUSIONS';
export const UPDATE_PLAN_CREATIVEFORMATS = 'UPDATE_PLAN_CREATIVEFORMATS';
export const UPDATE_PLAN_CREATIVEORIENTATIONS = 'UPDATE_PLAN_CREATIVEORIENTATIONS';
export const UPDATE_PLAN_CREATIVEORIENTATIONEXCLUSIONS = 'UPDATE_PLAN_CREATIVEORIENTATIONEXCLUSIONS';
export const UPDATE_PLAN_DAYPART = 'UPDATE_PLAN_DAYPART';
export const UPDATE_PLAN_DEMOGRAPHIC_TARGET_IDS = 'UPDATE_PLAN_DEMOGRAPHIC_TARGET_IDS';
export const UPDATE_PLAN_ENDDATE = 'UPDATE_PLAN_ENDDATE';
export const UPDATE_PLAN_ESTIMATED_AUDIENCE_CPM = 'UPDATE_PLAN_ESTIMATED_AUDIENCE_CPM';
export const UPDATE_PLAN_ESTIMATED_AVERAGE_AUDIENCE_CPM = 'UPDATE_PLAN_ESTIMATED_AVERAGE_AUDIENCE_CPM';
export const UPDATE_PLAN_ESTIMATED_AVERAGE_CPM = 'UPDATE_PLAN_ESTIMATED_AVERAGE_CPM';
export const UPDATE_PLAN_ESTIMATED_CPM = 'UPDATE_PLAN_ESTIMATED_CPM';
export const UPDATE_PLAN_GEOFENCE_GROUP_IDS = 'UPDATE_PLAN_GEOFENCE_GROUP_IDS';
export const UPDATE_PLAN_GEOFENCE_GROUP_EXCLUSION_IDS = 'UPDATE_PLAN_GEOFENCE_GROUP_EXCLUSION_IDS';
export const UPDATE_PLAN_GOAL = 'UPDATE_PLAN_GOAL';
export const UPDATE_PLAN_HEATMAPS = 'UPDATE_PLAN_HEATMAPS';
export const UPDATE_PLAN_IABCATEGORIES = 'UPDATE_PLAN_IABCATEGORIES';
export const UPDATE_PLAN_IABCATEGORYEXCLUSIONS = 'UPDATE_PLAN_IABCATEGORYEXCLUSIONS';
export const UPDATE_PLAN_IS_CPM_FROM_RATE_CARD = 'UPDATE_PLAN_IS_CPM_FROM_RATE_CARD';
export const UPDATE_PLAN_IS_MEASUREMENT_REQUESTED = 'UPDATE_PLAN_IS_MEASUREMENT_REQUESTED';
export const UPDATE_PLAN_LOCATIONEXCLUSIONIDS = 'UPDATE_PLAN_LOCATIONEXCLUSIONIDS';
export const UPDATE_PLAN_LOCATIONIDS = 'UPDATE_PLAN_LOCATIONIDS';
export const UPDATE_PLAN_MARKET_IDS = 'UPDATE_PLAN_MARKET_IDS';
export const UPDATE_PLAN_MARKETEXCLUSIONIDS = 'UPDATE_PLAN_MARKETEXCLUSIONIDS';
export const UPDATE_PLAN_MAXBIDCPM = 'UPDATE_PLAN_MAXBIDCPM';
export const UPDATE_PLAN_MEDIA_OWNER_IDS = 'UPDATE_PLAN_MEDIA_OWNER_IDS';
export const UPDATE_PLAN_MEDIATYPEEXCLUSIONIDS = 'UPDATE_PLAN_MEDIATYPEEXCLUSIONIDS';
export const UPDATE_PLAN_MEDIATYPEIDS = 'UPDATE_PLAN_MEDIATYPEIDS';
export const UPDATE_PLAN_MIN_CONCENTRATION_FACTOR = 'UPDATE_PLAN_MIN_CONCENTRATION_FACTOR';
export const UPDATE_PLAN_MIN_CONCENTRATION_VALUE = 'UPDATE_PLAN_MIN_CONCENTRATION_VALUE';
export const UPDATE_PLAN_MINSECONDSBETWEENPLAYS = 'UPDATE_PLAN_MINSECONDSBETWEENPLAYS';
export const UPDATE_PLAN_NAME = 'UPDATE_PLAN_NAME';
export const UPDATE_PLAN_NETWORKEXCLUSIONIDS = 'UPDATE_PLAN_NETWORKEXCLUSIONIDS';
export const UPDATE_PLAN_NETWORKFREQUENCYCAPS = 'UPDATE_PLAN_NETWORKFREQUENCYCAPS';
export const UPDATE_PLAN_NETWORKIDS = 'UPDATE_PLAN_NETWORKIDS';
export const UPDATE_PLAN_PACKAGE = 'UPDATE_PLAN_PACKAGE';
export const UPDATE_PLAN_PACKAGEGROUP_DEALS = 'UPDATE_PLAN_PACKAGEGROUP_DEALS';
export const UPDATE_PLAN_PACKAGEGROUP_ID = 'UPDATE_PLAN_PACKAGEGROUP_ID';
export const UPDATE_PLAN_PACKAGE_ID = 'UPDATE_PLAN_PACKAGE_ID';
export const UPDATE_PLAN_PLANFEE = 'UPDATE_PLAN_PLANFEE';
export const UPDATE_PLAN_PROPERTIES = 'UPDATE_PLAN_PROPERTIES';
export const UPDATE_PLAN_PURCHASE_TYPE = 'UPDATE_PLAN_PURCHASE_TYPE';
export const UPDATE_PLAN_SITEEXCLUSIONIDS = 'UPDATE_PLAN_SITEEXCLUSIONIDS';
export const UPDATE_PLAN_SITEIDS = 'UPDATE_PLAN_SITEIDS';
export const UPDATE_PLAN_STARTDATE = 'UPDATE_PLAN_STARTDATE';
export const UPDATE_PLAN_TARGETIMPRESSIONS = 'UPDATE_PLAN_TARGETIMPRESSIONS';
export const UPDATE_PLAN_TARGETING_CRITERIA = 'UPDATE_PLAN_TARGETING_CRITERIA';
export const UPDATE_PLAN_TTD_CAMPAIGN = 'UPDATE_PLAN_TTD_CAMPAIGN';
export const UPDATE_PLAN_UNITEXCLUSIONIDS = 'UPDATE_PLAN_UNITEXCLUSIONIDS';
export const UPDATE_PLAN_UNITIDS = 'UPDATE_PLAN_UNITIDS';
export const UPDATE_PLAN_UNITPACKEXCLUSIONIDS = 'UPDATE_PLAN_UNITPACKEXCLUSIONIDS';
export const UPDATE_PLAN_UNITPACKIDS = 'UPDATE_PLAN_UNITPACKIDS';
export const UPDATE_PLAN_UNITTAGEXCLUSIONS = 'UPDATE_PLAN_UNITTAGEXCLUSIONS';
export const UPDATE_PLAN_UNITTAGS = 'UPDATE_PLAN_UNITTAGS';
export const UPDATE_PLAN_JOURNEY_ID = 'UPDATE_PLAN_JOURNEY_ID';

// POSTAL CODES FILE
export const UPDATE_POSTAL_CODES_FILE_NAME = 'UPDATE_POSTAL_CODES_FILE_NAME';

// PRESALE HEATMAPS
export const UPDATE_PRESALEHEATMAP_DESCRIPTION = 'UPDATE_PRESALEHEATMAP_DESCRIPTION';
export const UPDATE_PRESALEHEATMAP_JSON = 'UPDATE_PRESALEHEATMAP_JSON';
export const UPDATE_PRESALEHEATMAP_NAME = 'UPDATE_PRESALEHEATMAP_NAME';
export const UPDATE_PRESALEHEATMAP_PUBLIC_PLAINTEXT_PASSWORD = 'UPDATE_PRESALEHEATMAP_PUBLIC_PLAINTEXT_PASSWORD';

// DATA PROVIDERS
export const UPDATE_DATAPROVIDER_EXTERNALDEMOGRAPHICS = 'UPDATE_DATAPROVIDER_EXTERNALDEMOGRAPHICS';
export const UPDATE_DATAPROVIDER_SELECTEDEXTERNALDEMOGRAPHICS = 'UPDATE_DATAPROVIDER_SELECTEDEXTERNALDEMOGRAPHICS';

// REPORT DEFINITIONS
export const UPDATE_REPORTDEFINITION_BREAKDOWN = 'UPDATE_REPORTDEFINITION_BREAKDOWN';
export const UPDATE_REPORTDEFINITION_DATES = 'UPDATE_REPORTDEFINITION_DATES';
export const UPDATE_REPORTDEFINITION_DIMENSIONS = 'UPDATE_REPORTDEFINITION_DIMENSIONS';
export const UPDATE_REPORTDEFINITION_EMAILTARGETS = 'UPDATE_REPORTDEFINITION_EMAILTARGETS';
export const UPDATE_REPORTDEFINITION_FILTERS = 'UPDATE_REPORTDEFINITION_FILTERS';
export const UPDATE_REPORTDEFINITION_LASTEXECUTED_ON = 'UPDATE_REPORTDEFINITION_LASTEXECUTED_ON';
export const UPDATE_REPORTDEFINITION_METRICS = 'UPDATE_REPORTDEFINITION_METRICS';
export const UPDATE_REPORTDEFINITION_NAME = 'UPDATE_REPORTDEFINITION_NAME';
export const UPDATE_REPORTDEFINITION_PREFERRED_RUNNER_TYPE = 'UPDATE_REPORTDEFINITION_PREFERRED_RUNNER_TYPE';
export const UPDATE_REPORTDEFINITION_REPORTSCHEDULES = 'UPDATE_REPORTDEFINITION_REPORTSCHEDULES';
export const UPDATE_REPORTDEFINITION_TIMEZONE = 'UPDATE_REPORTDEFINITION_TIMEZONE';
export const UPDATE_REPORTDEFINITION_DEFINITION_FORMAT = 'UPDATE_REPORTDEFINITION_DEFINITION_FORMAT';
export const UPDATE_REPORTDEFINITION_DEFAULT_OUTPUT_FORMAT = 'UPDATE_REPORTDEFINITION_DEFAULT_OUTPUT_FORMAT';

// REPORT SCHEDULES
export const UPDATE_REPORTSCHEDULE_DAYOFMONTH = 'UPDATE_REPORTSCHEDULE_DAYOFMONTH';
export const UPDATE_REPORTSCHEDULE_EXECUTIONTIMEZONE = 'UPDATE_REPORTSCHEDULE_EXECUTIONTIMEZONE';
export const UPDATE_REPORTSCHEDULE_FIRSTEVENT = 'UPDATE_REPORTSCHEDULE_FIRSTEVENT';
export const UPDATE_REPORTSCHEDULE_LASTEVENT = 'UPDATE_REPORTSCHEDULE_LASTEVENT';
export const UPDATE_REPORTSCHEDULE_RECURRINGPERIOD = 'UPDATE_REPORTSCHEDULE_RECURRINGPERIOD';

// SITES
export const UPDATE_SITE_ACTIVE = 'UPDATE_SITE_ACTIVE';
export const UPDATE_SITE_DESCRIPTION = 'UPDATE_SITE_DESCRIPTION';
export const UPDATE_SITE_EXTERNALID = 'UPDATE_SITE_EXTERNALID';
export const UPDATE_SITE_ISACTIVE = 'UPDATE_SITE_ISACTIVE';
export const UPDATE_SITE_ISSTREETVIEWIMAGEAVAILABLE = 'UPDATE_SITE_ISSTREETVIEWIMAGEAVAILABLE';
export const UPDATE_SITE_LATITUDE = 'UPDATE_SITE_LATITUDE';
export const UPDATE_SITE_LOCATIONID = 'UPDATE_SITE_LOCATIONID';
export const UPDATE_SITE_LONGITUDE = 'UPDATE_SITE_LONGITUDE';
export const UPDATE_SITE_NAME = 'UPDATE_SITE_NAME';
export const UPDATE_SITE_UNITS = 'UPDATE_SITE_UNITS';

// UNITS
export const UPDATE_UNIT_AD_SERVER_AVAILABLITY = 'UPDATE_UNIT_AD_SERVER_AVAILABLITY';
export const UPDATE_UNIT_ALLOWHTML = 'UPDATE_UNIT_ALLOWHTML';
export const UPDATE_UNIT_ALLOWIMAGE = 'UPDATE_UNIT_ALLOWIMAGE';
export const UPDATE_UNIT_ALLOWVIDEO = 'UPDATE_UNIT_ALLOWVIDEO';
export const UPDATE_UNIT_ALLOWZIP = 'UPDATE_UNIT_ALLOWZIP';
export const UPDATE_UNIT_ALLOWAUDIO = 'UPDATE_UNIT_ALLOWAUDIO';
export const UPDATE_UNIT_BLOCKUNIQUEADVERTISERIDS = 'UPDATE_UNIT_BLOCKUNIQUEADVERTISERIDS';
export const UPDATE_UNIT_DEAL_AVAILABILITY = 'UPDATE_UNIT_DEAL_AVAILABILITY';
export const UPDATE_UNIT_DESCRIPTION = 'UPDATE_UNIT_DESCRIPTION';
export const UPDATE_UNIT_ENABLE_STRICT_FREQUENCY_CAPPING = 'UPDATE_UNIT_ENABLE_STRICT_FREQUENCY_CAPPING';
export const UPDATE_UNIT_ENABLE_STRICT_IAB_BLOCK_CATEGORIES = 'UPDATE_UNIT_ENABLE_STRICT_IAB_BLOCK_CATEGORIES';
export const UPDATE_UNIT_EXTERNALID = 'UPDATE_UNIT_EXTERNALID';
export const UPDATE_UNIT_FACING_DIRECTION = 'UPDATE_UNIT_FACING_DIRECTION';
export const UPDATE_UNIT_FALLBACK_CREATIVES = 'UPDATE_UNIT_FALLBACK_CREATIVES';
export const UPDATE_UNIT_FLOORCPM = 'UPDATE_UNIT_FLOORCPM';
export const UPDATE_UNIT_GEOFENCE = 'UPDATE_UNIT_GEOFENCE';
export const UPDATE_UNIT_IAB_BLOCK_CATEGORIES = 'UPDATE_UNIT_IAB_BLOCK_CATEGORIES';
export const UPDATE_UNIT_IMAGE_URI = 'UPDATE_UNIT_IMAGE_URI';
export const UPDATE_UNIT_IMPRESSION_VERIFIER_VENDOR = 'UPDATE_UNIT_IMPRESSION_VERIFIER_VENDOR';
export const UPDATE_UNIT_IMPRESSION_VERIFIER_VENDOR_EXTERNAL_ID = 'UPDATE_UNIT_IMPRESSION_VERIFIER_VENDOR_EXTERNAL_ID';
export const UPDATE_UNIT_ISACTIVE = 'UPDATE_UNIT_ISACTIVE';
export const UPDATE_UNIT_ISSTREETVIEWIMAGEAVAILABLE = 'UPDATE_UNIT_ISSTREETVIEWIMAGEAVAILABLE';
export const UPDATE_UNIT_LATITUDE = 'UPDATE_UNIT_LATITUDE';
export const UPDATE_UNIT_LOCATIONID = 'UPDATE_UNIT_LOCATIONID';
export const UPDATE_UNIT_LONGITUDE = 'UPDATE_UNIT_LONGITUDE';
export const UPDATE_UNIT_LOOPLENGTH = 'UPDATE_UNIT_LOOPLENGTH';
export const UPDATE_UNIT_MAX_SPOTLENGTH = 'UPDATE_UNIT_MAX_SPOTLENGTH';
export const UPDATE_UNIT_MEDIATYPEID = 'UPDATE_UNIT_MEDIATYPEID';
export const UPDATE_UNIT_MIN_SECONDS_BETWEEN_AD_DOMAIN_PLAYS = 'UPDATE_UNIT_MIN_SECONDS_BETWEEN_AD_DOMAIN_PLAYS';
export const UPDATE_UNIT_MIN_SECONDS_BETWEEN_IAB_CATEGORY_PLAYS = 'UPDATE_UNIT_MIN_SECONDS_BETWEEN_IAB_CATEGORY_PLAYS';
export const UPDATE_UNIT_MIN_SPOTLENGTH = 'UPDATE_UNIT_MIN_SPOTLENGTH';
export const UPDATE_UNIT_NAME = 'UPDATE_UNIT_NAME';
export const UPDATE_UNIT_NETWORKID = 'UPDATE_UNIT_NETWORKID';
export const UPDATE_UNIT_OPEN_EXCHANGE_AVAILABILITY = 'UPDATE_UNIT_OPEN_EXCHANGE_AVAILABILITY';
export const UPDATE_UNIT_OPERATINGHOURS = 'UPDATE_UNIT_OPERATINGHOURS';
export const UPDATE_UNIT_PHYSICAL_SCREEN_HEIGHT = 'UPDATE_UNIT_PHYSICAL_SCREEN_HEIGHT';
export const UPDATE_UNIT_PHYSICAL_SCREEN_WIDTH = 'UPDATE_UNIT_PHYSICAL_SCREEN_WIDTH';
export const UPDATE_UNIT_PROPERTIES = 'UPDATE_UNIT_PROPERTIES';
export const UPDATE_UNIT_SCREENHEIGHT = 'UPDATE_UNIT_SCREENHEIGHT';
export const UPDATE_UNIT_SCREENWIDTH = 'UPDATE_UNIT_SCREENWIDTH';
export const UPDATE_UNIT_SITE = 'UPDATE_UNIT_SITE';
export const UPDATE_UNIT_SITEID = 'UPDATE_UNIT_SITEID';
export const UPDATE_UNIT_SPOTLENGTH = 'UPDATE_UNIT_SPOTLENGTH';
export const UPDATE_UNIT_TAGS = 'UPDATE_UNIT_TAGS';
export const UPDATE_UNIT_STORE_FRONT_AVIALABILTY = 'UPDATE_UNIT_STORE_FRONT_AVIALABILTY';
export const UPDATE_UNIT_TIMEZONE = 'UPDATE_UNIT_TIMEZONE';
export const UPDATE_UNIT_UNITLANGUAGES = 'UPDATE_UNIT_UNITLANGUAGES';
export const UPDATE_UNIT_UUID = 'UPDATE_UNIT_UUID';
export const UPDATE_UNIT_PHYSICAL_UNIT_COUNT = 'UPDATE_UNIT_PHYSICAL_UNIT_COUNT';
export const UPDATE_UNIT_HAS_PHYSICAL_UNIT_COUNT = 'UPDATE_UNIT_HAS_PHYSICAL_UNIT_COUNT';

// UNIT PACK
export const UPDATE_UNITPACK_NAME = 'UPDATE_UNITPACK_NAME';
export const UPDATE_UNITPACK_EXTERNALID = 'UPDATE_UNITPACK_EXTERNALID';
export const UPDATE_UNITPACK_ISACTIVE = 'UPDATE_UNITPACK_ISACTIVE';
export const UPDATE_UNITPACK_DESCRIPTION = 'UPDATE_UNITPACK_DESCRIPTION';

// USER
export const UPDATE_USER_PROFILEPICTURE = 'UPDATE_USER_PROFILEPICTURE';

// USER_ORGANIZATIONS
export const UPDATE_USER_ORGANIZATION_ROLEID = 'UPDATE_USER_ORGANIZATION_ROLEID';

// USER SETTINGS
export const UPDATE_USERSETTING_KEY = 'UPDATE_USERSETTING_KEY';
export const UPDATE_USERSETTING_VALUE = 'UPDATE_USERSETTING_VALUE';

// USER PROFILE
export const UPDATE_USERPROFILE_DISPLAYNAME = 'UPDATE_USERPROFILE_DISPLAYNAME';
